import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesModule } from '../comum/filtros/pipes/pipes.module';
import { ComumModule } from '../comum/comum.module';
import { routing } from '../rotas';
import { CadastroRoteiroComponent } from './cadastro-roteiro/cadastro-roteiro.component';
import { ListarRoteiroComponent } from './listar-roteiro/listar-roteiro.component';
import { ListarRoteirosUsuarioComponent } from './listar-roteiros-usuario/listar-roteiros-usuario.component';
import { VisaoRoteirosAtivosComponent } from './visao-roteiros-ativos/visao-roteiros-ativos.component';
import { FormsModule } from '@angular/forms';
import { RoteiroService } from './roteiro.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { CalendarModule as PrimeCalendarModule, ConfirmDialogModule, ConfirmationService, MultiSelectModule } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { ListarRoteiroInternoComponent } from './listar-roteiro-interno/listar-roteiro-interno.component';
import { RoteiroInternoComponent } from './roteiro-interno/roteiro-interno.component';
import { CalendarModule as FullCalendarModule } from 'ap-angular2-fullcalendar';
import { CadastroRoteiroInternoComponent } from './cadastro-roteiro-interno/cadastro-roteiro-interno.component';
import { Data } from '../comum/data/data';

@NgModule({
    imports: [
        CommonModule,
        NgxPaginationModule,
        NgbModule.forRoot(),
        PipesModule,
        ComumModule,
        routing,
        FormsModule,
        LoadingModule.forRoot({
            animationType: ANIMATION_TYPES.circle
        }),
        ConfirmDialogModule,
        PrimeCalendarModule,
        MultiSelectModule,
        FullCalendarModule
    ],
    declarations: [CadastroRoteiroComponent, ListarRoteiroComponent, VisaoRoteirosAtivosComponent, ListarRoteirosUsuarioComponent,
        ListarRoteiroInternoComponent, RoteiroInternoComponent, CadastroRoteiroInternoComponent],
    exports: [CadastroRoteiroComponent, ListarRoteiroComponent, VisaoRoteirosAtivosComponent, ListarRoteirosUsuarioComponent,
        ListarRoteiroInternoComponent, RoteiroInternoComponent, CadastroRoteiroInternoComponent],
    providers: [RoteiroService, ConfirmationService, CookieService, Data, DatePipe]
})
export class RoteiroModule { }



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/roteiro/roteiro.module.ts